export enum UserLinkedAccountsStatus {
  VALID = "VALID",
  INVALID = "INVALID",
}
